<div class="popup marginBottomStyle" 
    style="position: relative; overflow: scroll; height: 100%;overflow-x: hidden;">

    <div class="row topRowMargins headerStyle" style="margin-top: 0;">
      <div  style="margin-left: 15px;">
        <label class="textColour">Configure Dataset Visuals</label>
      </div>
    </div>
  <div class="container" style="margin: 0;padding: 0;" >
    <form novalidate [formGroup]='validations_form'>
        <div class="row">
            <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Select Dataset</mat-label>
                  <input matInput type="text"  [(ngModel)]="dataSetObject.datasetName" (click)="searchableDatasetsOnInsert()"
                    formControlName="selectdataSet" readonly required>
                    <mat-error *ngFor="let validation of validation_messages.selectdataSet">
                      <span
                        *ngIf="validations_form.get('selectdataSet').hasError(validation.type) && (validations_form.get('selectdataSet').dirty || validations_form.get('selectdataSet').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4">
                <mat-form-field class="filter" appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">Visual Name</mat-label>
                    <input matInput type="text" placeholder="Visual Name" formControlName="visualName"
                      [(ngModel)]="visualName" maxlength="100" required [readonly]="this.data.editData">
                <mat-error *ngFor="let validation of validation_messages.visualName">
                  <span
                    *ngIf="validations_form.get('visualName').hasError(validation.type) && (validations_form.get('visualName').dirty || validations_form.get('visualName').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
              </div>
              <div class="col-lg-4">
                <mat-form-field class="filter" appearance="outline">
                    <mat-label i18n="@@targetloginusername">
                        Visual Type
                    </mat-label>
                    <mat-select formControlName="selectVisualType" [(ngModel)]="dataSetObject.visualType" (selectionChange)="onVisualTypeChange($event)" [disabled]="this.data.editData">
                            <mat-option *ngFor="let tempObject of visualTypeData" [value]="tempObject.visualTypeName">
                                {{tempObject.visualTypeName}}
                            </mat-option>

                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.selectVisualType">
                      <span
                        *ngIf="validations_form.get('selectVisualType').hasError(validation.type) && (validations_form.get('selectVisualType').dirty || validations_form.get('selectVisualType').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
        </div>
    </form>
</div>

    <div class="container" style="margin: 0;padding: 0;" >
      <div class="row" *ngIf="dataSetObject.datasetName && dataSetObject.visualType != 'Pivot'">
        <!-- Table 1 (left side) -->
        <div class="col-4">
          <div class="seperateDiv">
            <mat-toolbar class="agGridtoperDiv card" style="
              background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
              border-right: 1px solid #a9a9a9a8;
              border-left: 1px solid #a9a9a9a8;height: 40px;">
              <label i18n="@@spmsUserReg" class="textColour" style="border: none!important;font-size: 18px;
    margin-bottom: 0;">Dataset Columns</label>
              <span class="example-spacer"></span>
            </mat-toolbar>
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTabularFields" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowMultiSelectWithClick]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true"
              [debug]="true" [components]="components"
              (gridReady)="onGridReadyForTabularFields($event,ngModelObjectTemporary)"
              (rowSelected)="onTabularShowInVisualsSelected($event)" [hidden]="!true" style="height: 58vh;">
            </ag-grid-angular>
          </div>
        </div>
        <div class="col-4">
          <div class="seperateDiv">
            <mat-toolbar class="agGridtoperDiv card" style="
            background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;height: 40px;">
            <label i18n="@@spmsUserReg" class="textColour" style="border: none!important;font-size: 18px;
    margin-bottom: 0;">Concatenation</label>
            <span class="example-spacer"></span>
          </mat-toolbar>
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTabularconcatinationFields" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowMultiSelectWithClick]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true"
              [debug]="true" [components]="components"
              (gridReady)="onGridReadyForTabularConcatinationFields($event,ngModelObjectTemporary)"
              (rowSelected)="onTabularConcatinationShowInVisualsSelected($event)" [hidden]="!true" style="height: 58vh;">
            </ag-grid-angular>
          </div>
        </div>
        <div class="col-4">
          <div class="seperateDiv">
            <mat-toolbar class="agGridtoperDiv card" style="
            background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;height: 40px;">
            <label i18n="@@spmsUserReg" class="textColour" style="border: none!important;font-size: 18px;
    margin-bottom: 0;">Aggregate</label>
            <span class="example-spacer"></span>
          </mat-toolbar>
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTabularAggregateFields" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowMultiSelectWithClick]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true"
              [debug]="true" [components]="components"
              (gridReady)="onGridReadyForTabularAggregateFields($event,ngModelObjectTemporary)"
              (rowSelected)="onTabularAggregateShowInVisualsSelected($event)" [hidden]="!true" style="height: 58vh;">
            </ag-grid-angular>
          </div>
        </div>
        <div class="col-4" *ngIf="dataSetObject.rollingUp.length > 0">
          <div class="seperateDiv">
            <mat-toolbar class="agGridtoperDiv card" style="
            background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;height: 40px;">
            <label i18n="@@spmsUserReg" class="textColour" style="border: none!important;font-size: 18px;
    margin-bottom: 0;">Rolling Up</label>
            <span class="example-spacer"></span>
          </mat-toolbar>
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTabularRollingUpFields" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowMultiSelectWithClick]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true"
              [debug]="true" [components]="components"
              (gridReady)="onGridReadyForTabularRollingFields($event,ngModelObjectTemporary)"
              (rowSelected)="onTabularRollingShowInVisualsSelected($event)" [hidden]="!true" style="height: 58vh;">
            </ag-grid-angular>
          </div>
        </div>
        </div>
      <div class="row" *ngIf="dataSetObject.datasetName && dataSetObject.visualType == 'Pivot'">
        <!-- Table 1 (left side) -->
        <div class="col-4">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTablesFields" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true"
              [debug]="true" [components]="components"
              (gridReady)="onGridReadyForTablesFields($event,ngModelObjectTemporary)"
              (rowSelected)="onRowSelected($event)" [hidden]="!true" style="height: 98vh;">
            </ag-grid-angular>
          </div>
        </div>
    
        <!-- Tables 2, 3, and 4 (right side) -->
        <div class="col-4">
          <!-- First row with Table 2 -->
          <div class="row mb-3">
            <div class="col-1 d-flex justify-content-center align-items-center">
              <!-- <div style="width: 2%;margin: 1%;font-size: 1.8rem;text-align:
              center;"> -->
              <div>
                <div (click)="pushDataToSelectedFieldsGrid('insert')" style="margin:50% 0;">
                  <em class="fas fa-step-forward" title="Move selected rows to
                    Right"></em>
                </div>
                <div (click)="removeSelectedRowData()"  style="margin:50% 0;">
                  <em class="fas fa-step-backward" title="Move selected rows to
                    Left"></em>
                </div>
              </div>
            <!-- </div> -->
            </div>
            <div class="col-11">
              <div class="seperateDiv">
                 <!-- ROWS -->
                <ag-grid-angular class="ag-theme-balham table-width-fields
                  tablestyles square scroolbar-dusty-grass square thin" style="height: 30vh;"
                  [columnDefs]="columnDefsForSelectedFields"
                  [defaultColDef]="defaultColDef" [animateRows]="true"
                  [rowDragManaged]="true"
                  (rowDragEnd)="onRowDragEnd($event)"
                  [sortingOrder]="sortingOrder"
                  [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
                  [headerHeight]="35"
                  (gridReady)="onGridReadyForSelectedTableFields($event,ngModelObjectTemporary)"
                  (rowSelected)="onRowSelectedToRemoveRows($event)"
                  (cellEditingStarted) = "onCellEditingStarted($event)"
                  (cellValueChanged)="onCellValueChanged($event)" [hidden]="!true">
                </ag-grid-angular>
              </div>
            </div>
          </div>
    
          <!-- Second row with Table 3 -->
          <div class="row mb-3">
            <div class="col-1 d-flex justify-content-center align-items-center">
              <div>
                <div (click)="pushDataToColumnsGrid('insert')" style="margin:50% 0;">
                  <em class="fas fa-step-forward" title="Move selected rows to
                    Right"></em>
                </div>
                <div (click)="removeSelectedColumnData()"  style="margin:50% 0;">
                  <em class="fas fa-step-backward" title="Move selected rows to
                    Left"></em>
                </div>
              </div>
            </div>
            <div class="col-11">
              <div class="seperateDiv">
                <!-- COLUMNS -->
                <ag-grid-angular class="ag-theme-balham table-width-fields
                  tablestyles square scroolbar-dusty-grass square thin" style="height: 30vh;"
                  [columnDefs]="columnDefsForSelectedColumns"
                  [defaultColDef]="defaultColDef" [animateRows]="true"
                  [rowDragManaged]="true"
                  (rowDragEnd)="onRowDragEnd($event)"
                  [sortingOrder]="sortingOrder"
                  [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
                  [headerHeight]="35"
                  (gridReady)="onGridReadyForColumns($event,ngModelObjectTemporary)"
                  (rowSelected)="onRowSelectedToRemoveColumns($event)"
                  (cellEditingStarted) = "onCellEditingStarted($event)"
                  (cellValueChanged)="onCellValueChanged($event)" [hidden]="!true">
                </ag-grid-angular>
              </div>
            </div>
          </div>
    
          <!-- Third row with Table 4 -->
          <div class="row">
            <div class="col-1 d-flex justify-content-center align-items-center">
              <div>
                <div (click)="pushDataToValuesGrid('insert')" style="margin:50% 0;">
                  <em class="fas fa-step-forward" title="Move selected rows to
                    Right"></em>
                </div>
                <div (click)="removeSelectedValueData()"  style="margin:50% 0;">
                  <em class="fas fa-step-backward" title="Move selected rows to
                    Left"></em>
                </div>
              </div>
            </div>
            <div class="col-11">
              <div class="seperateDiv">
                 <!-- Values -->
                <ag-grid-angular class="ag-theme-balham table-width-fields
                  tablestyles square scroolbar-dusty-grass square thin" style="height: 30vh;"
                  [columnDefs]="columnDefsForSelectedValues"
                  [defaultColDef]="defaultColDef" [animateRows]="true"
                  [rowDragManaged]="true"
                  (rowDragEnd)="onRowDragEnd($event)"
                  [sortingOrder]="sortingOrder"
                  [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
                  [headerHeight]="35"
                  (gridReady)="onGridReadyForValues($event,ngModelObjectTemporary)"
                  (rowSelected)="onRowSelectedToRemoveValues($event)"
                  (cellEditingStarted) = "onCellEditingStarted($event)"
                  (cellValueChanged)="onCellValueChanged($event)" [hidden]="!true">
                </ag-grid-angular>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="seperateDiv" style="height: 98vh;
          border: 1px solid darkgray;padding: 0;overflow-x: hidden;overflow-y: auto;">
            <div class="panel-container">
              <!-- Display Settings Panel -->
              <div class="panel">
                <div class="panel-header" (click)="togglePanel('panel1')">
                  <span class="arrow" [ngClass]="{ 'open': openPanels['panel1'] }"><i class="fas fa-angle-right"></i></span>
                  Display Settings
                </div>
                <div class="panel-body" *ngIf="openPanels['panel1']">
                  <p class="card-title" style="font-size: 14px;">CARD TITLE</p>
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCEnterValue">Edit Title</mat-label>
                    <input matInput type="text" maxlength="50" name="title"
                      [(ngModel)]="tableProperties.title" [title]="tableProperties.title ?tableProperties.title : '' ">
                  </mat-form-field>
                  <div class="input-group mb-3">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Edit Subtitle</mat-label>
                      <input matInput type="text" maxlength="50" name="subtitle"
                        [(ngModel)]="tableProperties.subTitle" [title]="tableProperties.subTitle ?tableProperties.subTitle : '' ">
                    </mat-form-field>
                    
                  </div>
                </div>
              </div>
            
              <!-- Pivot Options Panel -->
              <div class="panel">
                <div class="panel-header" (click)="togglePanel('panel2')">
                  <span class="arrow" [ngClass]="{ 'open': openPanels['panel2'] }"><i class="fas fa-angle-right"></i></span>
                  Pivot Options
                </div>
                <div class="panel-body" *ngIf="openPanels['panel2']">
                  <p class="card-title" style="font-size: 14px;">Layout</p>
                  <mat-radio-group class="example-radio-group" [(ngModel)]="tableProperties.layout">
                    <mat-radio-button class="example-radio-button"  value="HIERARCHY">
                      Hierarchy
                    </mat-radio-button>
                    <mat-radio-button class="example-radio-button"  value="TABULAR">
                      Tabular
                    </mat-radio-button>
                  </mat-radio-group> 
                  <!-- <p class="card-title" style="font-size: 14px;">Values Position</p>
                  <mat-radio-group class="example-radio-group" [(ngModel)]="tableProperties.valuesPosition">
                    <mat-radio-button class="example-radio-button"  value="HIERARCHY">
                      Rows
                    </mat-radio-button>
                    <mat-radio-button class="example-radio-button"  value="TABULAR">
                      Columns
                    </mat-radio-button>
                  </mat-radio-group>  -->
                </div>
              </div>

              <div class="panel" *ngIf="tableProperties.layout == 'HIERARCHY'">
                <div class="panel-header" (click)="togglePanel('panel3')">
                  <span class="arrow" [ngClass]="{ 'open': openPanels['panel3'] }">
                    <i class="fas fa-angle-right"></i>
                  </span>
                  Headers
                </div>
                <div class="panel-body" *ngIf="openPanels['panel3']">
                  <p class="card-title" style="font-size: 14px;">Rows</p>
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCEnterValue">Label</mat-label>
                    <input matInput type="text" maxlength="50" name="title"
                      [(ngModel)]="tableProperties.headers.rowsLabel" [title]="tableProperties.headers.rowsLabel ?tableProperties.headers.rowsLabel : '' ">
                  </mat-form-field>
                  <mat-form-field class="filter" appearance="outline">
                    <mat-label i18n="@@targetloginusername">
                      Visibility
                    </mat-label>
                    <mat-select name="columnsTotalPosition" [(ngModel)]="tableProperties.headers.visibility"  >
                            <mat-option  value="VISIBLE">
                                Visible
                            </mat-option>
                            <mat-option  value="HIDDEN">
                              Hidden
                          </mat-option>
                    </mat-select>
                </mat-form-field>
                </div>
              </div>
            
              <!-- TOTALS Panel -->
              <div class="panel">
                <div class="panel-header" (click)="togglePanel('panel4')">
                  <span class="arrow" [ngClass]="{ 'open': openPanels['panel4'] }">
                    <i class="fas fa-angle-right"></i>
                  </span>
                  Totals
                </div>
                <div class="panel-body" *ngIf="openPanels['panel4']">
                  <div class="spaceSeperate">
                    <p class="card-title" style="font-size: 14px;">Rows</p>
                    <mat-slide-toggle
                    class="example-margin"
                    [checked]="tableProperties.totalOptionsRowChecked"
                    [(ngModel)]="tableProperties.totalOptionsRowChecked"
                    >
                </mat-slide-toggle>
                  </div>
                  <div *ngIf="tableProperties.totalOptionsRowChecked" style="border-bottom: 1px solid #ccc;margin-bottom: 3%;">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Label</mat-label>
                      <input matInput type="text" maxlength="50" name="rowsTotalLabel"
                        [(ngModel)]="tableProperties.rowsTotal.label" [title]="tableProperties.rowsTotal.label ?tableProperties.rowsTotal.label : '' ">
                    </mat-form-field>
                    <mat-form-field class="filter" appearance="outline">
                      <mat-label i18n="@@targetloginusername">
                          Position
                      </mat-label>
                      <mat-select name="rowTotalPosition" [(ngModel)]="tableProperties.rowsTotal.position"  >
                              <mat-option  value="Top">
                                  Top
                              </mat-option>
                              <mat-option  value="Bottom">
                                Bottom
                            </mat-option>
                      </mat-select>
                  </mat-form-field>
                  </div>
                  <div class="spaceSeperate">
                    <p class="card-title" style="font-size: 14px;">Columns</p>
                    <mat-slide-toggle
                    class="example-margin"
                    [checked]="tableProperties.totalOptionsColumnsChecked"
                    [(ngModel)]="tableProperties.totalOptionsColumnsChecked"
                    >
                </mat-slide-toggle>
                  </div>
                  <div *ngIf="tableProperties.totalOptionsColumnsChecked">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Label</mat-label>
                      <input matInput type="text" maxlength="50" name="columnsTotalLabel"
                        [(ngModel)]="tableProperties.columnsTotal.label" [title]="tableProperties.columnsTotal.label ?tableProperties.columnsTotal.label : '' ">
                    </mat-form-field>
                    <mat-form-field class="filter" appearance="outline">
                      <mat-label i18n="@@targetloginusername">
                          Position
                      </mat-label>
                      <mat-select name="columnsTotalPosition" [(ngModel)]="tableProperties.columnsTotal.position"  >
                              <mat-option  value="Top">
                                  Top
                              </mat-option>
                              <mat-option  value="Bottom">
                                Bottom
                            </mat-option>
                      </mat-select>
                  </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="panel">
                <div class="panel-header" (click)="togglePanel('panel5')">
                  <span class="arrow" [ngClass]="{ 'open': openPanels['panel5'] }">
                    <i class="fas fa-angle-right"></i>
                  </span>
                  Subtotal
                </div>
                <div class="panel-body" *ngIf="openPanels['panel5']">
                  <div class="spaceSeperate">
                    <p class="card-title" style="font-size: 14px;">Rows</p>
                    <mat-slide-toggle
                    class="example-margin"
                    [checked]="tableProperties.subtotalOptionsRowChecked"
                    [(ngModel)]="tableProperties.subtotalOptionsRowChecked"
                    >
                </mat-slide-toggle>
                  </div>
                  <div *ngIf="tableProperties.subtotalOptionsRowChecked">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Label</mat-label>
                      <input matInput type="text" maxlength="50" name="rowsSubTotalLabel"
                        [(ngModel)]="tableProperties.rowsSubTotal.label" [title]="tableProperties.rowsSubTotal.label ?tableProperties.rowsSubTotal.label : '' ">
                    </mat-form-field>
                    <mat-form-field class="filter" appearance="outline">
                      <mat-label i18n="@@targetloginusername">
                          Level
                      </mat-label>
                      <mat-select name="rowsSubTotalLevel" [(ngModel)]="tableProperties.rowsSubTotal.level"  >
                              <mat-option  value="ALL">
                                ALL
                              </mat-option>
                              <mat-option  value="LAST">
                                LAST
                            </mat-option>
                            <mat-option  value="CUSTOM">
                              CUSTOM
                          </mat-option>
                      </mat-select>
                  </mat-form-field>
                  <!-- selectedRowsData -->
                  <mat-form-field class="filter" appearance="outline" *ngIf="tableProperties.rowsSubTotal.level == 'CUSTOM'" title="Note : Reason to remove last field is that last field cannot be selected as a subtotal field level">
                    <mat-label i18n="@@targetloginusername">
                      Select Rows
                  </mat-label>
                    <mat-select [(ngModel)]="tableProperties.rowsSubTotal.customAttributesSelected"   multiple name="rowsSubTotalColumnsSelected">
                      <mat-option *ngFor="let field of selectedRowsData | slice:0:-1" [(value)]="field.alias">
                        {{field.alias}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
                  </div>
                  <div class="spaceSeperate">
                    <p class="card-title" style="font-size: 14px;">Columns</p>
                    <mat-slide-toggle
                    class="example-margin"
                    [checked]="tableProperties.subtotalOptionsColumnsChecked"
                    [(ngModel)]="tableProperties.subtotalOptionsColumnsChecked"
                    >
                </mat-slide-toggle>
                  </div>
                  <div *ngIf="tableProperties.subtotalOptionsColumnsChecked">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Label</mat-label>
                      <input matInput type="text" maxlength="50" name="columnsSubTotalLabel"
                        [(ngModel)]="tableProperties.columnsSubTotal.label" [title]="tableProperties.columnsSubTotal.label ?tableProperties.columnsSubTotal.label : '' ">
                    </mat-form-field>
                    <mat-form-field class="filter" appearance="outline">
                      <mat-label i18n="@@targetloginusername">
                          Level
                      </mat-label>
                      <mat-select name="columnsSubTotalLevel" [(ngModel)]="tableProperties.columnsSubTotal.level"  >
                              <mat-option  value="ALL">
                                ALL
                              </mat-option>
                              <mat-option  value="LAST">
                                LAST
                            </mat-option>
                            <mat-option  value="CUSTOM">
                              CUSTOM
                          </mat-option>
                      </mat-select>
                  </mat-form-field>
                  <!-- Field is the last field and cannot be selected as a subtotal field level -->
                  <mat-form-field class="filter" appearance="outline" *ngIf="tableProperties.columnsSubTotal.level == 'CUSTOM'" title="Note : Reason to remove last field is that last field cannot be selected as a subtotal field level">
                    <mat-label i18n="@@targetloginusername">
                      Select Columns
                  </mat-label>
                    <mat-select [(ngModel)]="tableProperties.columnsSubTotal.customAttributesSelected"   multiple name="rowsSubTotalColumnsSelected">
                      <mat-option *ngFor="let field of selectedColumnsData | slice:0:-1" [(value)]="field.alias">
                        {{field.alias}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="panel">
                <div class="panel-header" (click)="togglePanel('panel6')">
                  <span class="arrow" [ngClass]="{ 'open': openPanels['panel6'] }"><i class="fas fa-angle-right"></i></span>
                  Sort Configuration
                </div>
                <div class="panel-body" *ngIf="openPanels['panel6']">
                  <p class="card-title" style="font-size: 14px;">Layout</p>
                  <mat-form-field class="filter" appearance="outline">
                    <mat-select [(ngModel)]="sortByList"   multiple name="multiselect">
                      <mat-option *ngFor="let field of visualObjectList" [(value)]="field.columnName">
                        {{field.columnName}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
                </div>
            </div>
            
            </div>
          </div>
      </div>
    </div>
    
    <div  class="row mb-1 topRowMargins" >

        <div class="col-lg text-center" >

            <div style="text-align: end">
                    <button *ngIf="dataSetObject.datasetName" i18n="@@TargetClear" type="button" (click)="sendDataAndClose()" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton">{{buttonName}}</button>

                    <button i18n="@@TargetCancel" type="button" (click)="closeFunction()"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton" >Cancel</button>        


            </div>
 
        </div>
        
    </div>
</div>